import React from 'react';

// import { NavLink } from 'react-router-dom';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Creators as signInActions } from '../../../domain/useCases/login/signInUseCase';

import LoginView from './LoginView';

interface Props {
  dispatch: Dispatch;
  isLoading: boolean;
  // error: string;
  // data: any;
}

const LoginViewController: React.FC<Props> = (props) => {
  const onLogin = (username: string, password: string) => {
    const { dispatch } = props;
    dispatch(signInActions.signIn(username.trim(), password.trim()));
  };

  const { isLoading } = props;

  return <LoginView onLogin={onLogin} isLoading={isLoading} />;
};

function mapStateToProps(state: any) {
  return {
    isLoading: state.auth.isLoading,
    error: state.auth.error,
    data: state.auth.data
  };
}
export default connect(mapStateToProps)(LoginViewController);
